import { Helmet } from "react-helmet";

interface SEOProps {
    title: string;
    description?: string;
    canonicalUrl?: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    ogUrl?: string;
    twitterCard?: string;
    /** Keep the page out of search results while still letting crawlers follow its links. */
    noindex?: boolean;
}

/**
 * Custom hook for handling SEO metadata
 * @param props SEO properties
 * @returns JSX element with Helmet component
 */
export const useSEO = (props: SEOProps) => {
    const {
        title,
        description,
        canonicalUrl,
        ogTitle = title,
        ogDescription = description,
        ogImage,
        ogUrl = canonicalUrl,
        twitterCard = "summary_large_image",
        noindex = false,
    } = props;

    return (
        <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            {noindex && <meta name="robots" content="noindex, follow" />}
            {canonicalUrl && !noindex && <link rel="canonical" href={canonicalUrl} />}

            {/* Open Graph tags */}
            <meta property="og:site_name" content="HittaPodd.se" />
            {ogTitle && <meta property="og:title" content={ogTitle} />}
            {ogDescription && <meta property="og:description" content={ogDescription} />}
            {ogImage && <meta property="og:image" content={ogImage} />}
            {ogUrl && <meta property="og:url" content={ogUrl} />}

            {/* Twitter Card */}
            {twitterCard && <meta name="twitter:card" content={twitterCard} />}
        </Helmet>
    );
};
